/**
 * returns a css transition property with the specified property and duration.
 *
 * `ease-in-out` is used for every transition and cannot be changed for now.
 *
 * @param property - name of the impacted property. `all` by default
 * @param duration - duration of the transition in ms. `240` by default
 */
export const transition = (property = 'all', duration = 240): string => {
  return `transition: ${property} ${duration}ms ease-in-out`;
};
